import { all, prop, not, o, has, isNil } from 'ramda'

interface OkFail {
	ok: boolean;
	string?: string;
	list?: any[];
	[key: string]: any;
}

function okFail (b: boolean, x: any = {}): OkFail {
	return { ok: b, data: x }
}
function ok (x?: any): OkFail {
	return okFail(true, x)
}
function fail (x?: any): OkFail {
	return okFail(false, x)
}
function isOK (o: OkFail): boolean {
	return prop('ok')(o) ?? false
}
function isFail (oo: OkFail): boolean {
	return o( not, isOK )(oo)
}
function ifOK (o: OkFail, ifFN: Function, elseFN?: Function): any {
	return isOK(o) ? ifFN(o) : (isNil(elseFN) ? fail(o) : elseFN(o))
}
function allOK (a: OkFail[]): boolean {
	return all((i: OkFail) => i.ok)(a)
}
function okPromise (x?: any): Promise<OkFail> {
	return Promise.resolve(ok(x))
}
function failPromise (x?: any): Promise<OkFail> {
	return Promise.resolve(fail(x))
}
function unOK (o: OkFail): any {
	if (has('ok')(o)) {
		delete o.ok
	}
	return o
}

export {
	OkFail,
	okFail, ok, fail, 
	isOK, isFail, allOK,
	ifOK, unOK,
	okPromise, failPromise
}